module.exports = __webpack_public_path__ + "img/logo_quick_hr.51c96092.png";